
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/vouchers",
      function () {
        return require("private-next-pages/admin/vouchers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/vouchers"])
      });
    }
  